//
export default [
  {
      text: "nombre",
      value: "name",
  },
  {
      text: "dirección",
      value: "address",
  },
  {
    text: "stock mínimo",
    value: "minimum_stock",
    align: "right",
    input: {
      reverse: true,
      type: "text-field"
    },
  },
  {
      text: "stock máximo",
      value: "maximum_stock",
      align: "right",
      input: {
          reverse: true,
          type: "text-field"
      },
  },
  {
      text: "stock critico",
      value: "critical_stock",
      align: "right",
      input: {
          reverse: true,
          type: "text-field"
      },
  },
]